import Link from 'next/link'
import styles from '../../styles/Applications.module.scss'
import { Col, Row, Button, Image } from 'react-bootstrap'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

interface ViewProps {
	textView: string
}

const JobCard: FC<ViewProps> = (props): JSX.Element => {
	const { t } = useTranslation()

	return (
		<>
			<Row className='text-center justify-content-center'>
				<Col md={3}>
					<Image src='/img/no-jobs-applied.png' alt='no-jobs' className={styles.image} />
					<p className={styles.desc}><strong>{t(props.textView)}</strong></p>
					<div className='d-grid gap-2'>
						<Link href='/browse-jobs' passHref>
							<Button variant='primary' className='text-white mb-4'>{t('root.browse')}</Button>
						</Link>
					</div>
				</Col>
			</Row>
		</>
	)
}

export default JobCard